import type { NavLinkComponent } from '@artic/ui/app-nav';
import { Link } from '@tanstack/react-router';

/**
 * Adapter that lets the shared `AppNav` navigate with TanStack Router without
 * `@artic/ui` taking a router dependency.
 *
 * The rest props matter: the nav mounts links through `asChild`, so Radix's
 * Slot injects `data-active` and friends here — dropping them would lose the
 * active-item highlight.
 */
export const RouterNavLink: NavLinkComponent = ({ to, children, ...props }) => (
  <Link to={to} {...props}>
    {children}
  </Link>
);
